import React from "react";
import { Stack, Avatar, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

export default function ProjectManager({ staff, nameOverride }) {
    const imgUrl =
        staff?.staff_profile_image?.profile_image_url ??
        staff?.profile_image_url ??
        null;

    const displayName = nameOverride ?? staff?.name ?? "-";

    return (
        <Stack direction="row" alignItems="center" spacing={2}>
            <Avatar
                src={imgUrl || undefined}
                alt={displayName}
                sx={{
                    width: 21,
                    height: 21,
                    bgcolor: "#F5C542",
                    color: "black",
                    "& svg": { fontSize: 14 },
                }}
            >
                {!imgUrl ? <PersonIcon /> : null}
            </Avatar>

            <Typography sx={{ fontWeight: 600, fontSize: 16, color: "#3b3b3b" }}>
                {displayName}
            </Typography>
        </Stack>
    );
}
